import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  LOCALE_ID,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Currency } from '@app/services/api/api.service';
import { LocaleInfo, LocaleService } from '@app/locale.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-locale-modal',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
  templateUrl: './locale-modal.component.html',
  styleUrl: './locale-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocaleModalComponent {
  public activeTab = 'locale';

  public locales: LocaleInfo[];
  public currencies: Currency[];
  public currentLocale: string;
  public currentCurrency: Observable<Currency>;

  private destroyed = new Subject<void>();

  constructor(
    private localeService: LocaleService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  ngOnInit() {
    this.locales = this.localeService.locales;
    this.currentLocale = this.locale;
    this.currentCurrency = this.localeService.currentCurrency;
    this.currencies = this.localeService.currencies;
    // this.currencies = this.localeService.currencies$
    //   .pipe(
    //     takeUntil(this.destroyed)
    //   );

    // this.currencies.subscribe();
  }

  trackByCurrency(i: number, currency: Currency) {
    return currency.code;
  }

  setLocale(locale: LocaleInfo) {
    // if (locale.name !== this.locale.name) {
    if (this.locale !== 'en') {
      window.location.href = `${window.location.origin}/${
        locale.name === 'en' ? '' : locale.name + '/'
      }${window.location.pathname.split('/').slice(2).join('/')}${
        window.location.search
      }`.replace(/(?<!:)(\/\/+)/g, '/');
    } else {
      window.location.href =
        `${window.location.origin}/${locale.name}/${window.location.pathname}${window.location.search}`.replace(
          /(?<!:)(\/\/+)/g,
          '/'
        );
    }
    // }
  }

  // getLocale(): LocaleInfo {
  //   const localeBaseHRef = window.location.pathname.split('/')[1];
  //   const locale = this.localeService.locales.find(lang => lang.name === localeBaseHRef);

  //   if (!locale) {
  //     return this.localeService.locales.find(lang => lang.name === 'en')!;
  //   }

  //   return locale;
  // }

  setCurrency(currency: Currency) {
    this.localeService.setCurrency(currency);
  }

  close() {
    this.localeService.closeLocaleModal();
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
